import { cppGetAppInfo } from '../api/cpp';
import { getProductBaseInfo } from '../api/em';
import { UiExtConf, DefaultMenuOption } from '../../src/componts/App/data';

const appInfo = cppGetAppInfo();
// const appInfo = {
//     appId: "bve7p4j1avfoni84mcv0",
//     version: "3.9.0"
// }

const publicurlResource = "https://yuneffect.com/emusic3web";
const assetUrl = (m) => (typeof m === 'string' ? m : (m && m.default) || '');
const defaultIco = assetUrl(require(`./default/logo.ico`));
const defaultPng = assetUrl(require(`./default/logo.png`));
const packageJson = require('../../package.json');

const defaultProductInfo = {
    appId: appInfo && appInfo.appId,
    version: appInfo && appInfo.version,
    pageVersion: packageJson.version,
    title: '云音盒电音助手',
    aboutTitle: '云音盒电音助手',
    ico: defaultIco,
    png: defaultPng,
    // 客服信息一律由后台下发（留空就是不显示），客户端不再内置任何默认值
    qr: '',
    helpPhone: '',
    helpWeiXin: '',
    helpQq: '',
    WindowIconFileName: 'WindowIcon.ico',
    webSite: {
        webSiteName: "",
        webSiteUrl: "",
    },
    menuOption: new DefaultMenuOption(),
    uiExtConf: new UiExtConf(),
    emusicDownUrl: '',
    shortName: '',
};

function getProductInfo () {
    return new Promise((resolve, reject) => {
        if (!appInfo || !appInfo.appId) {
            resolve(defaultProductInfo)
        } else {
            getProductBaseInfo({
                productId: appInfo.appId
            }).then(res => {
                if (res && res.err === 'ERR_OK' && res.product) {
                    let logoProductId = res.product.brandId;
                    let menuOption = new DefaultMenuOption();
                    let uiExtConf = new UiExtConf();                    
                    if (res.product.menuOption) {
                        try {
                            menuOption = JSON.parse(res.product.menuOption)
                        } catch (err) {
                        }
                    }
                    if (res.product.uiExtConf) {
                        try {
                            const cloudConf = JSON.parse(res.product.uiExtConf)                            
                            if (cloudConf && cloudConf.version === uiExtConf.version) {
                                uiExtConf = cloudConf
                            }
                        } catch (err) {
                        }
                    }
                    /* 客服信息：服务端带了 contactFrom 标记就完全按服务端来（空 = 不显示）。
                       老服务端没有这个标记，仍走「没填就用默认」的老逻辑。 */
                    const contactFromServer = res.product.contactFrom === 'server';
                    const productInfo = {
                        appId: appInfo.appId,
                        version: appInfo.version ? `v${appInfo.version}` : '',
                        pageVersion: packageJson.version,
                        title: res.product.upperProductName || res.product.productName,
                        aboutTitle: res.product.productName,
                        ico: defaultProductInfo.ico,
                        png: defaultProductInfo.png,
                        // 客服信息只看后台：留空就是不显示（客户端不再内置默认值）
                        qr: '',
                        helpPhone: res.product.helpPhone || '',
                        helpWeiXin: res.product.helpWeiXin || '',
                        helpQq: res.product.helpQq || '',
                        WindowIconFileName: 'WindowIcon.ico',
                        webSite: {
                            webSiteName: (res.product.webSite && res.product.webSite.webSiteName) || "",
                            webSiteUrl: (res.product.webSite && res.product.webSite.webSiteUrl) || "",
                        },
                        menuOption: menuOption,
                        uiExtConf: uiExtConf,
                        emusicDownUrl: res.product.emusicDownUrl || '',
                        shortName: res.product.shortName || '',
                    };
                    resolve(productInfo)
                } else {
                    resolve(defaultProductInfo)
                }
            }).catch(() =>{
                resolve(defaultProductInfo)
            })
        }
    })
}

export { defaultProductInfo }

export default getProductInfo
